import useConfigList from './useConfigList'

export default () => useConfigList('brands')
